<template>
  <CelusButton v-bind="$attrs" color="primary" variant="text">
    <slot />
  </CelusButton>
</template>

<script setup lang="ts">
import CelusButton from "@/components/util/CelusButton.vue";

defineOptions({
  name: "CelusTextButton",
  inheritAttrs: false,
});
</script>
